import React, { useEffect, useState } from "react";
import styles from "./UserProfile.module.scss";
import person from "../../assets/images/person.jpg";
import { MdOutlineModeEdit } from "react-icons/md";
import loading from "../../assets/images/loading.gif";
import { database } from "../../FirebaseConfig";
import { collection, addDoc, getDocs } from "firebase/firestore";
const UserProfile = () => {
  const userId = localStorage.getItem("userId");
  const role = localStorage.getItem("role");
  const [showLoading, setShowLoading] = useState(false);
  const collectionRef = collection(database, "users");
  useEffect(() => {
    document.title = "Briding 365 | User";
    window.scrollTo(0, 0);
    getUserData();
    if (receivedUserData) {
      alert("Profile already up to date");
    }
    // eslint-disable-next-line
  }, []);
  const editImgHandler = () => { };
  const [receivedUserData, setReceivedUserData] = useState();
  const getUserData = () => {
    setShowLoading(true);
    getDocs(collectionRef)
      .then((response) => {
        setReceivedUserData(
          response.docs
            .map((item) => {
              return { ...item.data(), id: item.id };
            })
            .filter((item) => item.userId === userId)[0]
        );
        // setUser1Data(
        //   response.docs.map((item) => {
        //     return { ...item.data(), id: item.id };
        //   })
        // );
        setShowLoading(false);
      })
      .catch((error) => {
        // console.log(error);
        setShowLoading(false);
      });
  };
  const today = new Date();
  const date =
    today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
  const time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  const [userData, setUserData] = useState({
    userId: userId,
    userImg: "",
    fName: "",
    lName: "",
    contact1: "",
    contact2: "",
    email: "",
    address: "",
    postalCode: "",
    country: "",
    state: "",
    city: "",
    joinedOnDate: date,
    joinedOnTime: time,
  });
  const formHandler = (e) => {
    e.preventDefault();

    if (
      !userData.userId ||
      // !userData.userImg ||
      !userData.fName ||
      !userData.lName ||
      !userData.postalCode ||
      !userData.country ||
      !userData.state ||
      !userData.email ||
      !userData.address ||
      !userData.contact2 ||
      !userData.city ||
      !userData.contact1
    ) {
      alert("Please fill all the details");
      return;
    }
    if (!userData.email.match(/[a-z0-9]+@[a-z]+.[a-z]{2,3}/)) {
      alert("Please enter valid email address");
      return;
    }
    if (!userData.postalCode.match(/^[a-zA-Z0-9 ]+$/)) {
      alert("Please enter valid postal code");
      return;
    }
    setShowLoading(true);
    // console.log(userData);
    addDoc(collectionRef, userData)
      .then((response) => {
        // console.log(response);
        alert("Profile updated successfully successfully ! ");
        setShowLoading(false);
      })
      .catch((error) => {
        // console.log(error);
        alert("Oops !! Something went wrong. ");
        setShowLoading(false);
      });
  };
  // eslint-disable-next-line
  const [isEditMode, setIsEditMode] = useState();
  const editHandler = (e) => {
    e.preventDefault();
    setIsEditMode(true);
    alert("Edit functionality to be added soon !");
  };
  return (
    <div className={styles.userProfile}>
      <p className={styles.welComeText}>Welcome {role} !</p>
      <form action="" className={styles.form}>
        <div className={styles.left}>
          <div className={styles.UserBox}>
            <div className={styles.imgContainer}>
              <MdOutlineModeEdit className={styles.editIcon} />
              <img src={person} alt="" onClick={editImgHandler} />
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.inputBoxContainer}>
            <div className={styles.inputBox}>
              <label htmlFor="">First name</label>
              <input
                type="text"
                placeholder="Enter first name"
                value={receivedUserData ? receivedUserData.fName : userData.fName}
                onChange={(e) =>
                  setUserData({ ...userData, fName: e.target.value })
                }
              />
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="">Last name</label>
              <input
                type="text"
                placeholder="Enter last name"
                value={receivedUserData ? receivedUserData.lName : userData.lName}
                onChange={(e) =>
                  setUserData({ ...userData, lName: e.target.value })
                }
              />
            </div> </div>

          <div className={styles.inputBox}>
            <label htmlFor="">Conact number</label>
            <input
              type="text"
              placeholder="Enter contact number"
              value={
                receivedUserData ? receivedUserData.contact1 : userData.contact1
              }
              onChange={(e) =>
                setUserData({ ...userData, contact1: e.target.value })
              }
            />
          </div>
          <div className={styles.inputBox}>
            <label htmlFor="">Alternate conact number (optional)</label>
            <input
              type="text"
              placeholder="Enter contact number"
              value={
                receivedUserData ? receivedUserData.contact2 : userData.contact2
              }
              onChange={(e) =>
                setUserData({ ...userData, contact2: e.target.value })
              }
            />
          </div>
          <div className={styles.inputBox}>
            <label htmlFor="">Email</label>
            <input
              type="email"
              placeholder="Enter email"
              value={receivedUserData ? receivedUserData.email : userData.email}
              onChange={(e) =>
                setUserData({ ...userData, email: e.target.value })
              }
            />
          </div>
          <div className={styles.inputBox}>
            <label htmlFor="">Address</label>
            <input
              type="text"
              placeholder="Enter address"
              value={
                receivedUserData ? receivedUserData.address : userData.address
              }
              onChange={(e) =>
                setUserData({ ...userData, address: e.target.value })
              }
            />
          </div>
          <div className={styles.inputBoxContainer}>
            <div className={styles.inputBox}>
              <label htmlFor="">Country</label>
              <input
                type="text"
                placeholder="Enter Country"
                value={
                  receivedUserData ? receivedUserData.country : userData.country
                }
                onChange={(e) =>
                  setUserData({ ...userData, country: e.target.value })
                }
              />
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="">State/region</label>
              <input
                type="text"
                placeholder="Enter State/region"
                value={receivedUserData ? receivedUserData.state : userData.state}
                onChange={(e) =>
                  setUserData({ ...userData, state: e.target.value })
                }
              />
            </div>
          </div>
          <div className={styles.inputBoxContainer}>
            <div className={styles.inputBox}>
              <label htmlFor="">City</label>
              <input
                type="text"
                placeholder="Enter city"
                value={
                  receivedUserData
                    ? receivedUserData.city
                    : userData.city
                }
                onChange={(e) =>
                  setUserData({ ...userData, city: e.target.value })
                }
              />
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="">Postal code</label>
              <input
                type="text"
                placeholder="Enter postal code"
                value={
                  receivedUserData
                    ? receivedUserData.postalCode
                    : userData.postalCode
                }
                onChange={(e) =>
                  setUserData({ ...userData, postalCode: e.target.value })
                }
              />
            </div>
          </div>




          {receivedUserData ? (
            <button
              type="submit"
              className={styles.saveBtn}
              onClick={editHandler}
            >
              Edit profile
            </button>
          ) : (
            <button
              type="submit"
              className={styles.saveBtn}
              onClick={formHandler}
            >
              Save profile
            </button>
          )}
        </div>
      </form>
      <div className={styles.loadingContainer}>
        {showLoading && (
          <img src={loading} className={styles.loadingImg} alt="" />
        )}
      </div>
    </div>
  );
};

export default UserProfile;
